import Vue from 'vue'
import { Toast } from 'vant';
Vue.use(Toast);

Vue.mixin({
    methods: {
        TOAST_Tip(message) {
            this.$toast({
                message,
                //icon: "https://gfhapi.zkungfu.com/image2/upload/common/H5/Icon_WarningToast.png"
                icon: "https://gfhapi202304.zkungfu.com/image2/upload/common/H5/Icon_WarningToast.png"
            });
        },
        TOAST_Success(message) {
            this.$toast({
                message,
                //icon: "https://gfhapi.zkungfu.com/image2/upload/common/H5/Icon_Success.png"
                icon: "https://gfhapi202304.zkungfu.com/image2/upload/common/H5/Icon_Success.png"
            });
        },
    }
})